export default __webpack_public_path__ + "static/media/design.8cd8157e.png";